import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import Button from "../../../../components/elements/Button";
import classes from "./WelcomeSection.module.scss";
import { ICONS } from "../../../../constants/icons";

type SectionCardProps = {
  title: string;
  description: string[];
  buttonTitle: string;
  buttonIcon?: React.ReactNode;
  handleClick: () => void;
  icon: string;
};

const SectionCard: FC<SectionCardProps> = ({ icon, title, description, buttonTitle, buttonIcon, handleClick }) => {
  return (
    <div className={classes.sectionCard}>
      <div className={classes.textInfo}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div className={classes.iconWrapper}>
            <img src={ICONS[icon]} alt="PlayBook icon" />
          </div>
          <Typography variant="h2" className={classes.title}>
            {title}
          </Typography>
        </div>
        <ul className={classes.description}>
          {description.map((item) => (
            <li key={item} className={classes.listItem}>
              {item}
            </li>
          ))}
        </ul>
      </div>

      <Button fullWidth variant="outlined" onClick={handleClick}>
        {buttonTitle}
        {buttonIcon}
      </Button>
    </div>
  );
};

export default SectionCard;
